export default __webpack_public_path__ + "static/media/Hradcany_sm.0548717b.jpg";